import config from "../config/consent-config";

// Get cookie user id
const getUserId = () => {
    if (typeof document === "undefined") return null;
    const name = "cookieconsent_userid="

    // Search from cookie
    const cookies = document.cookie.split(";");
    for (let c of cookies) {
        c = c.trim()
        if (c.startsWith(name)) {
            // Get the value of the cookie
            return c.substring(name.length)
        }
    }

    // If there is no cookie, generate one and store it
    const uuid = crypto.randomUUID();
    document.cookie = `cookieconsent_userid=${uuid}; Path=/; SameSite=Lax; Secure; Max-Age=31536000`

    return uuid
}

const generateDefaultConsent = (acceptall = false, regionData) => {
    /*
     * If regionData is present, follow the defaults by region
     * Otherwise, follow the acceptall boolean
     */
    if (regionData === undefined) {
        return generateConsentObj(acceptall);
    }
    const regiontype = regionData.type === "" ? "DEFAULT" : regionData.type;
    let tmpObj = generateConsentObj(false); // baseline reject all, then override
    if (regiontype === "TCF") {
        // EU / GDPR / TCF; unofficial TCF CMP should still follow this
        tmpObj.ads_data_redaction = true;
    } else {
        // Grant analytics if non-tcf
        tmpObj.analytics_storage = "granted";
        if (regiontype === "CPRA") {
            // California (CPRA)
            tmpObj.ads_data_redaction = true;
            tmpObj.sale_opt_out = false;
            tmpObj.sensitive_data_limit = false;
        } else if (regiontype === "VCDPA") {
            // VCDPA / Colorado / Virginia
            tmpObj.ad_storage = "granted";
            tmpObj.sale_opt_out = false;
        }
        // Maybe add more in the future
    }
    return tmpObj;
}

const generateConsentObj = (acceptall = false) => {
    const purposelist = getTCFPurposes();
    const grantedstr = acceptall ? "granted" : "denied";

    return {
        analytics_storage: grantedstr,
        ad_storage: grantedstr,
        ad_user_data: grantedstr,

        ad_personalization: grantedstr,
        sale_opt_out: !acceptall,
        sharing_opt_out: !acceptall, // Reverse of targeted_advertising
        targeted_advertising: grantedstr,
        profiling: grantedstr,

        functionality_storage: grantedstr,
        personalization_storage: grantedstr,

        // For Accept All / Reject All, these will be set outside
        sensitive_data_limit: true, // Always TRUE for TCF, can only be set to TRUE by VCDPA;  Also true for OTHERS to be safe because Brazil (LGPD), South Korea (PIPA), Thailand (PDPA), Singapore (PDPA).
        ads_data_redaction: false, // True only when (TCF or CPRA) && consent.ad_storage !== "granted"

        security_storage: "granted", // Always granted
        tcf: {
            purposes: purposelist.all.reduce((out, id) => {
                // Auto-check purposes not requiring consent under TCF v2.2
                out[id] = [5, 6, 8, 9, 10].includes(id) ? true : acceptall;
                return out;
            }, {}),
            legitimateInterests: {},
            specialFeatures: {},
            vendors: config.tcfvendorlist.reduce((out, item) => {
                out[item.vendorid] = acceptall;
                return out;
            }, {}),
            vendorLegitimateInterests: {},
            specialPurposes: { 1: true, 2: true, 3: true } // Always granted
        },
        nontcf: {
            vendors: config.tcfnonvendorlist.reduce((out, item) => {
                out[item.vendorid] = acceptall;
                return out;
            }, {})
        }
    };
}


const getTCFPurposes = () => {
    const vendors = [...config.tcfvendorlist, ...config.tcfnonvendorlist];
    const allPurposes = vendors.flatMap(v => v.purposeidlist);
    const unique = [...new Set(allPurposes)];

    // Only purposes requiring consent under TCF v2.2
    const consentPurposes = [1, 3, 4, 7];

    return {
        consent: unique.filter(p => consentPurposes.includes(p)).sort((a, b) => a - b),
        all: unique
    };
}

// Assumes Google Tag Manager (GTM) - Data Layer
const pushConsentUpdate = (userId, consent) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "consent_update",
        userId,
        consent,
    })
}

// This is done after saving to database
const pushConsentWrite = (userId, consent, mode = "PUT") => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "consent_write",
        userId,
        mode,
        consent,
    })
}

const applyGoogleConsent = (consent, initialization = false) => {
    // Already checked outside
    //if (typeof window === "undefined") return;
    //window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };

    window.gtag("consent", initialization ? "default" : "update", {
        ad_storage: consent.ad_storage,
        analytics_storage: consent.analytics_storage,
        ad_user_data: consent.ad_user_data,
        ad_personalization: consent.ad_personalization,
        functionality_storage: consent.functionality_storage,
        personalization_storage: consent.personalization_storage,
        security_storage: "granted", // Always granted
        wait_for_update: initialization ? 2000 : 500 // Recommended for GTM
    });

    // TODO: Own control/field; "Safe" mode for now
    window.gtag("set", "ads_data_redaction", consent.ads_data_redaction);
}

export {
    getUserId,
    generateDefaultConsent,
    getTCFPurposes,
    pushConsentUpdate,
    pushConsentWrite,
    applyGoogleConsent
}